export default __webpack_public_path__ + "static/media/css.c32d3b6a.png";